import React from "react";
import { Layout } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { useAuth } from "../../../authentication";
import UserProfile from "../../Sidebar/UserProfile";
import { toggleCollapsedSideNav } from "../../../appRedux/actions";
import { TAB_SIZE } from "../../../constants/ThemeSetting";
import styles from "./appHeader.module.css";

const { Header } = Layout;

const NAV_ITEMS = [
  { key: "tracking", to: "/tracking", label: "Tracking", icon: "icon-location" },
  { key: "paths", to: "/paths", label: "Paths", icon: "icon-timeline" },
  { key: "status", to: "/status", label: "Status", image: "/assets/images/list.png" },
];

const AppHeader = () => {
  const { authUser } = useAuth();
  const navCollapsed = useSelector(({ common }) => common.navCollapsed);
  const width = useSelector(({ common }) => common.width);
  const pathname = useSelector(({ common }) => common.pathname);
  const dispatch = useDispatch();

  const isActive = (to) => pathname.toLowerCase().startsWith(to);

  return (
    <Header className={styles.headerRoot}>
      {width < TAB_SIZE && (
        <div
          className={styles.hamburger}
          onClick={() => dispatch(toggleCollapsedSideNav(!navCollapsed))}
        >
          <i className="icon icon-menu" />
        </div>
      )}

      <Link to="/tracking" className={styles.logo}>
        <img alt="Stracon" src="/assets/images/logo.png" />
      </Link>

      {width >= TAB_SIZE && authUser.is_active && (
        <nav className={styles.nav}>
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.key}
              to={item.to}
              className={`${styles.navItem} ${isActive(item.to) ? styles.navItemActive : ""}`}
            >
              {item.image ? (
                <img className={styles.navImg} src={item.image} alt="" />
              ) : (
                <i className={`icon ${item.icon} ${styles.navIcon}`} />
              )}
              {item.label}
            </Link>
          ))}
          <a
            className={styles.navItem}
            href={`${process.env.REACT_APP_ADMIN_URL || "https://tracking-admin.stracontech.com"}/`}
          >
            <i className={`icon icon-setting ${styles.navIcon}`} />
            Admin
          </a>
        </nav>
      )}

      <div className={styles.right}>
        <UserProfile />
      </div>
    </Header>
  );
};

export default AppHeader;
